import { render, staticRenderFns } from "./interface.vue?vue&type=template&id=86ae39b4&scoped=true"
import script from "./interface.vue?vue&type=script&lang=js"
export * from "./interface.vue?vue&type=script&lang=js"
import style0 from "./interface.vue?vue&type=style&index=0&id=86ae39b4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ae39b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86ae39b4')) {
      api.createRecord('86ae39b4', component.options)
    } else {
      api.reload('86ae39b4', component.options)
    }
    module.hot.accept("./interface.vue?vue&type=template&id=86ae39b4&scoped=true", function () {
      api.rerender('86ae39b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/ComponentDetails/components/interface.vue"
export default component.exports